﻿import { dateFormat, currencySymbol } from 'filters'
import { confirm, extendReservationModal, reservationDetails as viewReservation } from 'components/modals'
import { prepareExtendData, getEarlyCheckinExtendDetails, isEarlyCheckinAllowed } from 'utils/extendReservation'
import { hasPermits } from 'directives'
import toastr from 'toastr'
import moment from 'moment-timezone'

const directives = {
  hasPermits
}

const filters = {
  dateFormat
}

const components = {
  confirm, viewReservation, extendReservationModal
}

const methods = {
  showReservationDetails (reservation_id, item) {
    this.$set(this.loadings, item.id, true);
    this.active_checkin_item = item;
    this.$store.dispatch('dashboards.getReservation', {
      'item': item
    });
    this.$store.dispatch('locations.getReservation', {
      lId: this.location.id,
      id: reservation_id
    }).then(() => {
      this.loadings[item.id] = false;
      let errors = _.cloneDeep(this.$store.state.locations.errors);
      if (errors ) {
        toastr.error(errors.message);
      } else {
        this.reservation = this.$store.state.locations.active_reservation;
        this.$refs.view.open('check-in', item);
      }
    });

    return false;
  },
  getList () {
    this.loading = true;
    let type = this.type;
    let date = this.date;
    if (this.type == 'all') {
      type = null;
    }
    this.$store.dispatch('dashboards.getCheckinList', {
      location_id: this.location.id,
      params: {
        checked_in: this.checked_in,
        type,
        date,
        _q: this.search_key
      }
    }).then(() => {
      this.loading = false;
      this.all_list = _.cloneDeep(this.list);
      this.total_checkins_count = this.list.length;
      if (this.type == 'all') {
        this.room_checkins_count = _.filter(this.list, (item) => {
          return item.type_type == 'room';
        }).length;
      }
    });
  },

  toggleCheck (item) {

    let now = moment(moment(), ['YYYY-MM-DD HH:mm:ss']).tz(this.location.timezone.code);
    let from = moment(item.from_date).tz(this.location.timezone.code, true);

    if (!item.check_in && now.isBefore(from) && this.location.extend_reservation_when_check_out) {
      if (!isEarlyCheckinAllowed(now, item.from_date, this.location.timezone.code)) {
        toastr.error(`Early check-in is allowed only within 72 hours before the start date.`);
        return;
      }

      this.loadings[item.id] = true;
      this.loadings = _.cloneDeep(this.loadings);

      this.prepareData(item);

      this.$store.dispatch('reservations.costs', {id: item.history.reservation.id, data: this.form}).then(() => {
        let errors = _.cloneDeep(this.$store.state.reservations.errors);
        if (errors) {
          toastr.error(errors.message);
          this.errors = errors.errors;
          this.loadings[item.id] = false;
        } else {
          this.costs = _.cloneDeep(this.$store.state.reservations.costs);
          let { amount_to_pay, diff } = getEarlyCheckinExtendDetails(this.costs, this.costsActiveHistory, from, now);
          this.amount_to_pay = amount_to_pay;

          if (Number(this.amount_to_pay) > 0) {
            let currency_code = this.location.currency ? currencySymbol(this.location.currency.code) : "Na";
            this.$refs.extendReservationModal.open(item, this.amount_to_pay, diff, this.location.timezone.code, currency_code, 'check-in');
          } else {
            this.loadings[item.id] = false;
            this.loadings = _.cloneDeep(this.loadings);
            this.checkIn(item);
          }
        }
      })
    } else {
      this.checkIn(item);
    }

  },

  checkIn (item) {
    if (item.check_in) {
      this.$refs.confirm.confirm('Are you sure?', () => {
        this.checkReservation(item.id, this.location.id);
      });
    } else {
      this.checkReservation(item.id, this.location.id);
    }
  },

  updateReservation(type, item) {
    if (type == 'charge' && !this.location.block_extending_reservations) {
      this.errors = {}
      this.costs = null;

      this.prepareData(item);
      this.loadings[item.id] = true;
      this.loadings = _.cloneDeep(this.loadings);
      this.$store.dispatch('reservations.update', {id: item.history.reservation.id, data: this.form}).then(() => {
        let errors = _.cloneDeep(this.$store.state.reservations.errors);
        if (errors) {
          toastr.error(errors.message);
          this.errors = errors.errors;
        } else {
          let reservation = _.cloneDeep(this.$store.state.reservations.active);
          let active_history = _.find(reservation.history, h => h.active);
          _.forEach(active_history.dates, (date) => {
            if (date.type_type != 'bundle' && date.type_type == item.type_type && date.type_id == item.type_id && date.to_date == item.to_date) {
              this.checkIn(date);
            }
          });
          toastr.success("Data has been saved");
          this.getList();
        }
      }).finally(() => {
        this.processing = false;
        this.loadings[item.id] = false;
        this.loadings = _.cloneDeep(this.loadings);
      })
    } else if ((type == 'without_charge' || this.location.block_extending_reservations) && type != 'dont_checkout') {
      this.checkIn(item);
      this.processing = false;
      this.loadings[item.id] = false;
      this.loadings = _.cloneDeep(this.loadings);
    } else {
      this.processing = false;
      this.onCloseModal();
    }
  },

  updateProcessing(processing) {
    this.processing = processing;
  },

  onCloseModal() {
    if (!this.processing) {
      this.loadings = {};
    }
    this.$emit('close');
  },

  checkReservation (id, location_id) {
    this.$store.dispatch('dashboards.checkInReservation', {
      id, location_id
    }).then(() => {
      let errors = _.cloneDeep(this.$store.state.dashboards.errors);
      if (errors) {
        if (errors.message.includes('This reservation is already cancelled')) {
          toastr.error(errors.message);
          setTimeout(() => {
            this.$router.go();
          }, "2000")
        }
      }
    });
  },

  toggleShow (item) {
    this.$store.dispatch('dashboards.showReservation', {
      'id': item.id, 'from': 'location'
    });
  },

  search (value) {
    if (value.length) {
      this.search_key = value;
    } else {
      this.search_key = null;
    }
    this.getList();
  },
  onSearchKeyup(value, e) {
    if (!value.length || e.keyCode == 13) {
      this.search(value);
    }
  },

  prepareData(item) {
    this.form = prepareExtendData(item, this.location, 'check-in');
  },

  getLicensePlate (item) {
    let license_plate = '';
    let text_license_plate ='';
    for (let i in item.history.extra_fields) {
      let extra_field = item.history.extra_fields[i];
      if (extra_field.input_type == 'license_plate' && extra_field.value.length > 0) {
        if (license_plate.length > 0) {
          license_plate += ", ";
        }
        license_plate += Array.isArray(extra_field.value) ? extra_field.value.join(', ') : extra_field.value;
      } else if (extra_field.input_type == 'text' && extra_field.name.includes('license')) {
        if (text_license_plate.length > 0) {
          text_license_plate += ", ";
        }
        text_license_plate += Array.isArray(extra_field.value) ? extra_field.value.join(', ') : extra_field.value;
      }
    }
    return license_plate.length > 0 ? license_plate : text_license_plate;
  }
}

const computed = {
  list () {
    return _.cloneDeep(this.$store.state.dashboards.checkin_list) || []
  },

  costsActiveHistory() {
    return this.costs ? _.find(this.costs.old_reservation.history, h => h.active) : null;
  },
}

const watch = {
  location (n) {
    this.getList();
  },
  date () {
    this.getList();
  }
}

export default {
  name: 'checkin-list',
  props: ['location', 'date'],
  methods,
  watch,
  computed,
  filters,
  components,
  directives,
  data () {
    return {
      loading: false,
      loadings: {},
      processing: false,
      type: 'all',
      checked_in: 'both',
      search_key: null,
      reservation: null,
      room_checkins_count: 0,
      total_checkins_count: 0,
      all_list: null,
      amount_to_pay: 0,
      form: {
        reservation_number: null,
        extra_fields: [],
        items: []
      },
      costs: null,
      has_license_plate: false,
    }
  },
  created () {
    if (this.location){
      this.getList();
      if (this.location.extra_fields.some(extra_field => extra_field.input_type == 'license_plate' || 
        (extra_field.input_type == 'text' && extra_field.name.includes('license')))) {
        this.has_license_plate = true;
      } else {
        this.has_license_plate = false;
      }
    }
  }
}
